module.exports = __webpack_public_path__ + "img/explain_line_white.7234b8f0.svg";